import QuestionCreator from '../questionCreator';
import TaskDetails from '../../../components/shared/TaskDetails';

import { IQuestionComponentProps } from '../types';

import { HISTORY_TYPE } from '../../../constants';

import imgFillingSurvey from '/images/filling-survey.svg';

const FamilyHistoryComponent: React.FC<IQuestionComponentProps> = ({
  isQuestionnaireComplete,
  questionnaires,
  toggleQuestionnaireCompletion,
  navigateToTasks,
}) => {
  if (isQuestionnaireComplete) {
    return (
      <TaskDetails
        title="Family History"
        description="Complete our pre-surgery questionnaire to ensure your safety and receive personalized care."
        buttonText="Complete questionnaire"
        imgSrc={imgFillingSurvey}
        imgAlt="filling-survey"
        imgWidth="287px"
        handleClick={toggleQuestionnaireCompletion}
        handleClose={navigateToTasks}
      />
    );
  }

  if (questionnaires)
    return (
      <QuestionCreator
        questionnaires={questionnaires}
        historyType={HISTORY_TYPE.FAMILY}
      />
    );

  return null;
};

export default FamilyHistoryComponent;
